import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export * from './dataGrid';
export * from './date';
export * from './env';
export * from './file';
export * from './hardReload';
export * from './i18n';
export * from './keyboardNavigation';
export * from './lift';
export * from './markedText';
export * from './newTab';
export * from './number';
export * from './qualityZone';
export * from './richText';
export * from './rowSelection';
export * from './scroll';
export * from './stableStringify';
export * from './string';
export * from './targetRate';
export * from './threshold';
export * from './timeRangeFilter';
export * from './tableFilterValue';
export * from './tableUtils';
export * from './textDiff';
export * from './toast';
export * from './truncation';
export * from './types';
export * from './zodValidators';

export function groupBy<T, K extends string | symbol | number>(array: T[], keyGetter: (item: T) => K): Record<K, T[]> {
  return array.reduce(
    (result, item) => {
      const key = keyGetter(item);
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(item);
      return result;
    },
    {} as Record<K, T[]>,
  );
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Пауза на заданное время.
 * `signal` прекращает её досрочно: ожидание завершается сразу после отмены, а таймер
 * снимается — иначе отменённая пауза доживала бы свой срок, копя таймеры при частых отменах.
 */
export const delay = (ms: number, signal?: AbortSignal): Promise<void> =>
  new Promise((resolve) => {
    if (signal?.aborted) {
      resolve();
      return;
    }

    let timer: ReturnType<typeof setTimeout>;

    const finish = () => {
      clearTimeout(timer);
      signal?.removeEventListener('abort', finish);
      resolve();
    };

    timer = setTimeout(finish, ms);
    signal?.addEventListener('abort', finish);
  });
